import React from "react";
import ReactHtmlParser from "react-html-parser";

export default function PostExcerpt(props) {
  const { post } = props;

  return (
    <div className="search-post">
      <div className="search-post-date">
        <div className="date-circle">
          <div className="date-number">
            {new Date(post.date.fulldate).getDate()}
          </div>
          <div className="date-text">{post.date.month}</div>
        </div>
      </div>
      <div className="search-post-data">
        <h3 className="search-post-title">
          <a href={post.url}>{post.title}</a>
        </h3>
        <div className="search-post-content">
          <p>{ReactHtmlParser(post.content)}</p>
        </div>
      </div>
    </div>
  );
}
